<div fxLayout="row wrap">
    <div class="premiere-featured-guest" fxFlex=60>

    <h3 class="featured-guest-heading" *ngIf="eventId">
        Featured Guests
        <hr class="featured-guest-headingHr"> 
    </h3>
    <h3 class="featured-heading" style="font-family: 'Lato' !important;" *ngIf="eventid">
        Featured Guests
        <hr class="featured-headingHr">
    </h3>
    <span class="introduction" *ngIf="eventId">
        Enjoy the exciting Artists of Cinejoy on the Red Carpet, during Q&A’s, and more.
    </span>

    <span class="introduction-symposiums" *ngIf="eventid" style="font-family: 'Lato' !important;">
        Enjoy these inspiring presenters. Click on their box to open full bio.
    </span>

</div>

<!--spotlight featured guest-box -->
<div class="drag" *ngIf="spot">
<drag-scroll  >
 
    <div drag-scroll-item class="scroll-item">

        <div  class="featured-guest-div" fxLayout="row" fxLayoutGap="5px">
        
            <div class="featured-guest"  *ngFor="let details of premiereDetails.cinejoyFeaturedGuests" fxLayoutGap="6px">
                
                <div class="featured-guest-image"  fxFlex="">
            
                    <span>
                        
                        <img class="image" src="{{details.img}}"/>
            
                    </span> 
                
                </div>
                
                <div class="featured-guest-info-div dragscroll" fxFlex="90" fxLayout="column"> 
            
                    <h3   class="featured-guest-info">
                        {{details.mainText}} &nbsp; &nbsp; &nbsp; 
                    </h3>

                    <h3 class="introduction">
                        {{details.subText}}
                    </h3> 
                </div>

            </div>
            
        </div>

    </div>
    
</drag-scroll>

</div>
<!-- featured guest-box ended-->

<!--celebration featured guest-box -->
<div class="drag celebration" style="overflow-x: auto; display: flex;" *ngIf="!spot">
    <drag-scroll>

        <div drag-scroll-item class="scroll-item scroll" >

            <div class="featured-guest-div" fxLayout="row" fxLayoutGap="5px">

                <div class="featured-guest" *ngFor="let details of premiereDetails.featuredGuests"
                    fxLayoutGap="6px" (click)="openFeaturedGuestDetails(details)">

                    <div class="featured-guest-image" fxFlex="">

                        <span>

                            <img class="image1" src="{{details.imageUrl}}" />

                        </span>

                    </div>

                    <div class="featured-guest-info-div dragscroll" fxFlex="100" fxLayout="column">

                        <h3 class="featured-guest-info" style="font-family: 'Lato-Bold' !important;">
                            {{details.name}} &nbsp; &nbsp; &nbsp;
                        </h3>

                        <h3 class="introduction" style="font-family: 'Lato-Bold' !important;">
                            {{details.description}}
                        </h3>
                    </div>

                </div>

            </div>

        </div>

    </drag-scroll>

    <ng-template #dialogTemplate let-dialogRef="dialogRef" let-data>
        <div fxLayout="column" class="main-container" >
            <div class="close-icon-container">
                <button class="close-icon" (click)="dialogRef.close()">
                    <i class="bi bi-x-lg" style="font-size: 28px;"></i>
                </button>
            </div>
            <div fxLayout="row" class="custom-dialog-container">
                <div class="guest-image-container">
                    <img class="guest-image" src="{{ data.image }}" alt="guest-image">
                </div>
                <div fxFlex="100%" class="flex-column">
                    <p style="font-family: 'Lato' !important;" class="guest-title">{{ data.name }}</p>
                    <div *ngIf="data.title?.length > 0 || data.companyName?.length > 0">
                        <ng-container *ngIf="areBothPresent(data.title, data.companyName); else elseBlock">
                            <p style="font-family: 'Lato' !important;" class="role">{{ data.title }}</p>
                            <p style="font-family: 'Lato' !important;" class="company">{{ data.companyName }}</p>
                        </ng-container>
                        <ng-template #elseBlock>
                            <p style="font-family: 'Lato' !important;" class="role">{{ data.title || data.companyName }}</p>
                        </ng-template>
                        <p *ngIf="!(data.title?.length > 0 || data.companyName?.length > 0)">
                            <span class="featured-bio" style="font-family: 'Lato' !important;">{{ data.bio }}</span>
                        </p>
                        <p *ngIf="data.title?.length > 0 || data.companyName?.length > 0">
                            <span class="bio" style="font-family: 'Lato' !important;">{{ data.bio }}</span>
                        </p>
                    </div>
                </div> 
            </div>
        </div>
    </ng-template>

</div>
<!--celebration featured guest-box ended-->

</div>